/* ============================================================
   pbg-cart.js  (v1, July 15, 2026)
   Palm Beach Gems: maison-style remove confirmation in the
   cart drawer. Clicking the trash button fades the line items
   and shows an inline "Remove Product?" confirm. Yes performs
   the original remove; Cancel or Esc dismisses.

   Scoped to #cart-drawer only: the full cart page keeps native
   behavior. Fully additive: if this script fails or is removed,
   the trash button behaves exactly as before (the intercept is
   the only change, and it fails open to the native remove).
   Styles live in pbg-horizon-overrides.css (section 6).
   ============================================================ */
(function () {
  'use strict';

  var pendingBtn = null;
  var hostEl = null;

  function buildConfirm() {
    var el = document.createElement('div');
    el.className = 'pbg-remove-confirm';
    el.setAttribute('role', 'alertdialog');
    el.setAttribute('aria-label', 'Remove product?');
    el.innerHTML =
      '<p class="pbg-remove-confirm__title">Remove Product?</p>' +
      '<p class="pbg-remove-confirm__text">Are you sure you want to remove the following product from the cart?</p>' +
      '<div class="pbg-remove-confirm__actions">' +
      '<button type="button" class="pbg-remove-confirm__btn" data-pbg-rc-cancel>Cancel</button>' +
      '<button type="button" class="pbg-remove-confirm__btn pbg-remove-confirm__btn--yes" data-pbg-rc-yes>Yes</button>' +
      '</div>';
    return el;
  }

  function closeConfirm() {
    if (!hostEl) return;
    var c = hostEl.querySelector('.pbg-remove-confirm');
    if (c) c.remove();
    hostEl.classList.remove('pbg-rc-active', 'pbg-rc-host');
    hostEl = null;
    pendingBtn = null;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;

      /* Confirm buttons */
      if (e.target.closest('[data-pbg-rc-cancel]')) {
        e.preventDefault();
        e.stopPropagation();
        closeConfirm();
        return;
      }
      if (e.target.closest('[data-pbg-rc-yes]')) {
        e.preventDefault();
        e.stopPropagation();
        var btn = pendingBtn;
        closeConfirm();
        if (btn) {
          btn.dataset.pbgRcBypass = '1';
          btn.click(); /* replays the native remove */
        }
        return;
      }

      /* Intercept the drawer's trash button */
      var remove = e.target.closest('#cart-drawer .cart-items__remove');
      if (!remove) return;
      if (remove.dataset.pbgRcBypass) {
        delete remove.dataset.pbgRcBypass; /* confirmed: let it through */
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      closeConfirm(); /* only one confirm at a time */
      var host =
        remove.closest('.cart-drawer__content') ||
        document.querySelector('#cart-drawer .cart-drawer__inner');
      if (!host) {
        /* No host to anchor on: fail open to the native remove */
        remove.dataset.pbgRcBypass = '1';
        remove.click();
        return;
      }
      hostEl = host;
      pendingBtn = remove;
      host.classList.add('pbg-rc-active', 'pbg-rc-host');
      var confirm = buildConfirm();
      host.appendChild(confirm);
      var cancel = confirm.querySelector('[data-pbg-rc-cancel]');
      if (cancel) cancel.focus();
    },
    true /* capture: runs before Horizon's own remove handler */
  );

  /* Esc closes the confirm only, not the drawer under it */
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape' || !hostEl) return;
      e.preventDefault();
      e.stopPropagation();
      closeConfirm();
    },
    true
  );

  /* The drawer body re-renders on cart updates: if our host node
     got replaced mid-confirm, drop the stale state. */
  document.addEventListener('cart:update', closeConfirm);
  document.addEventListener('theme:cart:update', closeConfirm);
})();
